import { render, staticRenderFns } from "./PlaceCategories.vue?vue&type=template&id=7c312454&"
import script from "./PlaceCategories.vue?vue&type=script&lang=js&"
export * from "./PlaceCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports